export { default } from './JsonLdScript';
